export default "__VITE_ASSET__DD$$IqcQ__$_?component__"